/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagListResponse } from '../../models/tag-list-response';

export interface GetAssociationsByEntity$Params {
  'Active-Tenant-Identifier': string;
  id: string;
}

export function getAssociationsByEntity(http: HttpClient, rootUrl: string, params: GetAssociationsByEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<TagListResponse>> {
  const rb = new RequestBuilder(rootUrl, getAssociationsByEntity.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagListResponse>;
    })
  );
}

getAssociationsByEntity.PATH = '/associations/entity/{id}';
